import { TableColumns } from 'interfaces';

export const ASSOCIATED_INVESTORS_PAGE_TITLE = 'Associated Investors';

export const ASSOCIATED_INVESTORS_TABLE_COLUMNS: TableColumns[] = [
  { id: 'name', title: 'Name' },
  { id: 'email', title: 'Email' },
  { id: 'totalShares', title: 'Total Shares' },
  { id: 'totalCurrentValue', title: 'Total Current Value (£)' },
  { id: 'averagePricePerShare', title: 'Average Price Per Share (£)' },
  { id: 'percentageShare', title: 'Percentage Share' },
];
